export default [
  { title: 'Explora', to: '/assets' },
  { title: 'Favoritos', to: '/favourites' },
  { title: 'Precios', to: '/pricing' },
  { title: 'Privacidad', to: '/privacy-policy' }
];
